{
  "ui": {
    "feedback": "Feedback",
    "credits": "Riconoscimenti",
    "currentMaintainer": "Manutenzione attuale",
    "maintainerPeriod": "Dal 2026",
    "originalTeam": "Team originale",
    "creditsCampaigns": "Giungla e Natale",
    "moreSettings": "Altre impostazioni",
    "chooseLanguage": "Scegli la tua lingua",
    "notebookTools": "Strumenti del quaderno",
    "visualGuide": "Guida illustrata",
    "templeSoon": "In arrivo",
    "playAdventure": "Gioca",
    "story": "La storia",
    "loadingAdventure": "Prepariamo l’avventura…",
    "storyOpening": "Una gita scolastica nella giungla. Marco e Sophia esplorano con gli amici. Un uccello colorato attira Marco, che lo segue tra gli alberi. All’improvviso è solo. Aiuta gli esploratori a ritrovare la strada!",
    "storyEnding": "Marco e Sophia arrivano insieme al tempio perduto. Un volto misterioso sorveglia l’ingresso. Li aspetta una nuova avventura!",
    "blockCategories": "Schede del quaderno",
    "actions": "Azioni",
    "loops": "Cicli",
    "conditions": "Condizioni",
    "title": "Run Marco! — Un’avventura nel tuo quaderno",
    "home": "Pagina iniziale di Run Marco",
    "map": "Mappa dell’avventura",
    "worlds": "Scegli un’avventura",
    "notebook": "Il mio quaderno",
    "notebookToggle": "Apri o chiudi il quaderno",
    "notebookOpen": "Apri il quaderno",
    "notebookClose": "Guarda il sentiero",
    "page": "Pagina {number}",
    "level": "Percorso {number}",
    "run": "Andiamo!",
    "stop": "Ferma",
    "step": "Un passo",
    "stepTitle": "Esegui un’istruzione",
    "reset": "Torna alla partenza",
    "add": "Aggiungi",
    "addLabel": "Scegli un blocco da aggiungere",
    "addHint": "Unisci i blocchi, poi premi Gioca.",
    "undo": "Annulla",
    "clear": "Pagina nuova",
    "hint": "Un piccolo indizio",
    "help": "Come si gioca",
    "settings": "Impostazioni",
    "language": "Lingua del gioco",
    "blockLanguage": "Lingua dei blocchi",
    "blockLanguageNote": "Puoi scegliere un’altra lingua per i blocchi.",
    "musicOn": "Attiva l’audio",
    "musicOff": "Disattiva l’audio",
    "sound": "Musica ed effetti sonori",
    "speed": "Velocità dell’avventura",
    "chooseExplorer": "Scegli il tuo esploratore",
    "explorer": "Esploratore",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Chiudi",
    "done": "Esploriamo!",
    "loading": "Cerchiamo il sentiero…",
    "loadError": "Impossibile caricare l’avventura. Ricarica la pagina per riprovare.",
    "imageError": "Alcune immagini non si sono caricate. Ricarica la pagina.",
    "gemGoal": "Trova la gemma",
    "goal": "Trova la stella dorata",
    "cover": "Illumina ogni casella una sola volta",
    "lit": "{count} / {total} caselle illuminate",
    "explored": "{count} / {total} percorsi esplorati",
    "facing": "Verso {direction} {arrow}",
    "boardLabel": "{name} su {level}, verso {direction}. {steps}. {objective}.",
    "up": "l’alto",
    "down": "il basso",
    "left": "sinistra",
    "right": "destra",
    "steps_one": "{count} passo",
    "steps_other": "{count} passi",
    "blocks_one": "{count} blocco",
    "blocks_other": "{count} blocchi",
    "stars_one": "{count} stella",
    "stars_other": "{count} stelle",
    "place": "Aggiungi blocchi",
    "atEnd": "Alla fine",
    "insideRepeat": "Dentro ripeti {number}",
    "insideIf": "Dentro se {number}",
    "insideElse": "Dentro altrimenti {number}",
    "readyFirst": "Un piccolo passo. Aggiungi un blocco avanti e andiamo!",
    "ready": "Dove andiamo? Prepara un piano nel quaderno.",
    "back": "Di nuovo alla partenza. I tuoi blocchi sono pronti per riprovare.",
    "empty": "Prima aggiungi un blocco nel quaderno.",
    "win": "Hai trovato la strada!",
    "winCover": "Hai illuminato il sentiero!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Che avventura!",
    "simpler": "Riesci a usare meno blocchi?",
    "complete": "Percorso completato! Le tue stelle migliori sono salvate.",
    "next": "Percorso successivo",
    "allWorlds": "Altre avventure",
    "replay": "Gioca ancora",
    "shortGoal": "Quasi! Aggiungi qualche blocco per raggiungere la stella.",
    "shortGem": "Quasi! Aggiungi qualche blocco per raggiungere la gemma.",
    "shortCover": "Alcune caselle sono ancora buie. Come le raggiungiamo?",
    "checking": "Osserviamo il sentiero…",
    "paused": "In pausa. Gioca ricomincia dall’inizio.",
    "going": "Si parte!",
    "stepped": "Un passo più vicino. Premi Un passo o Gioca per continuare.",
    "clueCover": "Parti da un bordo e segui tutta la figura. Un salto supera una casella senza illuminarla.",
    "clueCondition": "Guarda il sentiero davanti a te. Una condizione aiuta il tuo esploratore a scegliere cosa fare.",
    "clueRepeat": "Quali passi si ripetono? Metti quel motivo dentro un blocco ripeti.",
    "clueForward": "Avanti segue lo sguardo dell’esploratore. Conta le caselle fino alla stella.",
    "clueGem": "Avanti segue lo sguardo dell’esploratore. Conta le caselle fino alla gemma.",
    "clueTurn": "Girare cambia direzione senza avanzare. Segui il sentiero con il dito.",
    "mapNote": "Scegli un percorso. Le tue stelle migliori restano salvate.",
    "mapLevel": "Percorso {number}: {name}. {stars}.",
    "locked": "Completa il percorso precedente per sbloccare questo.",
    "soundBlocked": "Tocca il pulsante dell’audio per ascoltare l’avventura.",
    "clearTitle": "Passiamo a una pagina nuova?",
    "clearNote": "I blocchi di questo percorso saranno cancellati. Annulla può ripristinarli.",
    "keep": "Conserva i miei blocchi",
    "clearConfirm": "Cancella i blocchi",
    "fresh": "Una pagina nuova. Dove ci porterà il tuo prossimo piano?",
    "localProgress": "I tuoi progressi sono salvati su questo dispositivo.",
    "helpBuild": "Prepara un piano",
    "helpBuildText": "Trascina i blocchi nel quaderno e uniscili, oppure toccali per aggiungerli. Scegli «Dentro ripeti» per inserire passi in un ciclo.",
    "helpTurn": "Segui il tuo esploratore",
    "helpTurnText": "Avanti segue il suo sguardo. Sinistra e destra fanno girare sul posto. Un salto percorre due caselle.",
    "helpTry": "Prova, guarda, riprova",
    "helpTryText": "Premi Gioca per provare il piano o Un passo per una sola istruzione. La freccia curva torna alla partenza conservando i blocchi.",
    "helpWorlds": "Ogni avventura ha un obiettivo",
    "helpWorldsText": "Nella Giungla, trova la gemma. A Natale, illumina ogni casella libera una volta. Nel Tempio e nell’Egeo, completa le riparazioni e gli obiettivi visibili, poi raggiungi l’uscita.",
    "noTrail": "Lì non c’è un sentiero! Prova a girare prima di avanzare.",
    "broken": "Quel ponte è rotto. Riesci a saltarlo?",
    "blocked": "Qualcosa blocca la strada. Prova un salto o un altro percorso.",
    "alreadyLit": "Quella casella è già illuminata. Visita ogni casella una sola volta.",
    "loopError": "Questo piano si ripete senza fine. Prova a cambiare il ciclo.",
    "repeatError": "Scegli un numero di ripetizioni da 1 a 99.",
    "unsupported": "Rimuovi il blocco non supportato e riprova.",
    "connect": "Unisci i blocchi in una sola catena, poi premi Gioca.",
    "path": "sentiero",
    "steps_many": "{count} passi",
    "blocks_many": "{count} blocchi",
    "stars_many": "{count} stelle",
    "backpack": "Zaino",
    "templeGems": "Gemme del tempio",
    "gemsCollected": "Gemme: {count} / {total}",
    "gemsReady": "Hai raccolto tutte le gemme!",
    "aegeanTitle": "I misteri dell’Egeo",
    "harbour": "Porto",
    "aegeanDescription": "Esplora il porto: ripara le postazioni, riutilizza le routine e invia un numero con ogni incarico.",
    "templeBetaNote": "Beta · Stiamo rivedendo gli enigmi e le lezioni",
    "aegeanBetaNote": "Beta · I primi 3 livelli del porto",
    "seasonal": "Avventura stagionale",
    "choosePreview": "Scegli un livello di anteprima",
    "repairs": "Riparazioni",
    "reachExit": "Raggiungi l’uscita",
    "taskRequirements": "Obiettivi della missione",
    "lessonGuided": "Esercizio guidato · completa il programma fornito",
    "lessonRepair": "Debug · correggi il programma fornito",
    "lessonChallenge": "Sfida · crea il tuo programma",
    "acc_define_parameter": "Routine",
    "acc_call_argument": "Chiama routine",
    "acc_repeat_parameter": "Ripeti con l’ingresso",
    "parameter": "parametro",
    "argument": "invia",
    "callInput": "Ingresso di questa chiamata",
    "inputWaiting": "Esegui il programma o avanza un’istruzione alla volta per vedere il prossimo ingresso.",
    "argumentMismatch": "Una routine con un parametro richiede una chiamata con un numero. Senza parametro, usa una chiamata normale.",
    "unsetParameter": "Usa il parametro solo nella routine che lo riceve. I parametri sono separati dalla memoria condivisa.",
    "memoryObjective": "Controlla il registro delle riparazioni e gli obiettivi di uscita. Ogni programma che li soddisfa è accettato.",
    "gate": "Il passaggio è bloccato. Controlla le riparazioni incomplete.",
    "noPickup": "Posizionati sull’attrezzo prima di raccoglierlo.",
    "creditLead": "Direzione del team e sviluppo software",
    "creditArt": "Illustrazione e scenari",
    "creditAnimation": "Animazione",
    "creditUX": "Progettazione dell’interfaccia e dell’esperienza utente",
    "creditDesign": "Progettazione del gioco",
    "creditStory": "Scrittura della storia",
    "creditAudio": "Musica e ingegneria del suono",
    "lightLamp": "Accendi la lampada",
    "oilLamp": "Lampada a olio",
    "dustyStation": "postazione polverosa",
    "betaLabel": "Beta",
    "noLamp": "Posizionati su una lampada spenta prima di accenderla.",
    "collected": "Strumento raccolto · pronto all’uso",
    "dustyPrompt": "Posizionati su una stazione polverosa prima di usare il pennello.",
    "lampMissing": "Raccogli prima la lampada a olio. Guarda nello zaino.",
    "recursiveRoutine": "Questa routine chiama sé stessa. Usa un’altra routine; le chiamate ricorsive non sono ancora disponibili."
  },
  "content": {
    "jungle.title": "Spedizione nella giungla",
    "jungle.description": "Segui il sentiero fino al tempio perduto.",
    "jungle-1": "Primi passi",
    "jungle-2": "Un po’ più lontano",
    "jungle-3": "Dietro l’angolo",
    "jungle-4": "Cambia direzione",
    "jungle-5": "Segui il sentiero",
    "jungle-6": "Un nuovo percorso",
    "jungle-7": "Nuovi sentieri",
    "jungle-8": "Incrocio nella giungla",
    "jungle-9": "Trova la strada",
    "jungle-10": "Pensa in anticipo",
    "jungle-11": "Il lungo sentiero",
    "jungle-12": "Un percorso tortuoso",
    "jungle-13": "Un salto coraggioso",
    "jungle-14": "Appaiono i motivi",
    "jungle-15": "Ripeti il ritmo",
    "jungle-16": "Scegli un sentiero",
    "jungle-17": "Guarda prima di saltare",
    "jungle-18": "Leggi il sentiero",
    "jungle-19": "Una deviazione astuta",
    "jungle-20": "Sotto le chiome",
    "jungle-21": "Costruttore di ponti",
    "jungle-22": "Oltre il fiume",
    "jungle-23": "Esplora le rovine",
    "jungle-24": "Pietra e legno",
    "jungle-25": "Un salto più grande",
    "jungle-26": "Segui gli indizi",
    "jungle-27": "Più in alto",
    "jungle-28": "Continua a esplorare",
    "jungle-29": "Sentieri tortuosi",
    "jungle-30": "Il giardino segreto",
    "jungle-31": "Motivi nascosti",
    "jungle-32": "Antichi sentieri",
    "jungle-33": "Le ultime curve",
    "jungle-34": "Verso il tempio",
    "jungle-35": "Ci siamo quasi",
    "jungle-36": "Il tempio perduto",
    "winter.title": "Sentiero d’inverno",
    "winter.description": "Lascia una luce in ogni impronta.",
    "winter-1": "Passi nella neve",
    "winter-2": "Un’altra direzione",
    "winter-3": "Angoli ghiacciati",
    "winter-4": "Il giro lungo",
    "winter-5": "Fiocco di neve",
    "winter-6": "Cicli d’inverno",
    "winter-7": "Esploratore del ghiaccio",
    "winter-8": "Curve e svolte",
    "winter-9": "Logica gelida",
    "winter-10": "Cercatore di motivi",
    "winter-11": "Maestro del sentiero",
    "winter-12": "Meraviglia d’inverno",
    "temple.title": "Il tempio perduto",
    "temple.description": "Quaranta stanze collegate: restaura uno strumento celeste con attrezzi, memoria e le tue routine."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Cestino vuoto",
    "OPEN_TRASH": "Apri il cestino",
    "BLOCK_LABEL_BEGIN_STACK": "Inizio della pila",
    "WORKSPACE_LABEL_1_STACK": "1 pila di blocchi",
    "WORKSPACE_LABEL_MANY_STACKS": "%1 pile di blocchi",
    "ARIA_TYPE_FIELD_NUMBER": "numero",
    "ARIA_TYPE_FIELD_DROPDOWN": "elenco a discesa",
    "ARIA_TYPE_FIELD_IMAGE": "immagine",
    "WORKSPACE_LABEL_PLAIN": "Il mio quaderno",
    "FIELD_LABEL_EDIT_PREFIX": "Modifica %1",
    "BLOCK_LABEL_HAS_INPUT": "ha un ingresso",
    "BLOCK_LABEL_HAS_INPUTS": "ha ingressi",
    "BLOCK_LABEL_HAS_BRANCHES": "ha %1 rami",
    "FIELD_LABEL_OPTION_INDEX": "Opzione %1",
    "INPUT_LABEL_EMPTY": "Vuoto",
    "BLOCK_LABEL_DISABLED": "disattivato",
    "BLOCK_LABEL_COLLAPSED": "compresso",
    "BLOCK_LABEL_BEGIN_PREFIX": "Inizio: %1",
    "INPUT_LABEL_END_STATEMENT": "Fine: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "testo",
    "ARIA_TYPE_FIELD_INPUT": "ingresso",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "nome dell’ingresso",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "nome della routine"
  }
}
